define('lib/Podio.UI.DynamicContent',['require','underscore','jquery','lib/Podio.Router.Content','lib/shouldUseOverlay','lib/Podio.Utils'],function (require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var podioContentRouter = require('lib/Podio.Router.Content');
  var shouldUseOverlay = require('lib/shouldUseOverlay');
  var utils = require('lib/Podio.Utils');

  var navigate = _.debounce(function(url, options) {
    podioContentRouter.navigate(url, options);
  }, 700, true);

  var resolveNavigation = function(e, url) {
    // If we shouldn't open in an overlay
    // or if the user intended open links in a different way, let them
    if (!shouldUseOverlay(url) || utils.isMetaEvent(e)) {
      return true;
    }

    // Using setTimeout to let other document event handlers,
    // like React, intercept the event and prevent default
    setTimeout(function () {
      // Only navigate if someone else already hasn't intercepted and done the navigation for us
      if (url !== document.location.href) {
        navigate(url, { renderType: 'overlay' });
      }
    }, 20);

    return false;
  };

  function onLinkClicked(e) {
    return resolveNavigation(e, e.currentTarget.href);
  }

  // These selectors will not be targeted for the event listener
  var IGNORE_SELECTORS = [
    '.PodioUI__Notifications__NotificationGroup'
  ];

  // Attach handler to all relevant anchor tags
  $(document).on('click', 'a[href*="/apps/"]:not('+ IGNORE_SELECTORS.join(',') + ')', onLinkClicked);

  return {
    resolveNavigation: resolveNavigation
  }
});

